import { trackEvent } from '../../_common/client/tracking';

export const registerClickTracking = (container: HTMLElement) => {
    container.addEventListener('click', () => {
        trackEvent({ product_TopInfoActivity: 'click' });
    });
};
